export default () => {
    const videoEls = [...document.querySelectorAll('.js-accessible-video')];

    videoEls.forEach((el) => {
        const video = el.querySelector('video');
        const button = el.querySelector('button')

        // Pause video after 5 seconds and show button to continue playing in popup.
        video.addEventListener('timeupdate', () => {
            const currentTime = video.currentTime;
            if (currentTime >= 5) {
                video.pause();
                button.setAttribute('data-video-current-time', currentTime);
                button.classList.remove('is-hidden');
            }
        });
    })
};